"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Deck = void 0;
const CARD_RENAMES = new Map([]);
class Deck {
    constructor(cards) {
        this.factories = new Map(cards.map((cf) => [cf.cardName, cf]));
    }
    findByCardName(name) {
        const updatedName = CARD_RENAMES.get(name);
        if (updatedName !== undefined) {
            name = updatedName;
        }
        return this.factories.get(name);
    }
}
exports.Deck = Deck;
//# sourceMappingURL=Deck.js.map